import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dynamic from 'next/dynamic';

import {
  actions as modalActions,
} from '@gc-npm/reducers.modals-reducer';
import { COLOR_DICTIONARY } from '@gc-npm/utils.enums.colors';
import Glyph from '@gc-npm/components.icon-glyph';
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_KIND,
  TEXT_DISPLAY,
} from '@gc-npm/components.text';
import sendGaEvent from '@gc-npm/utils.metrics.send-ga-component-event';
import { getModuleNamesTagginInfo } from '@/utils/index';

import { CONFIRMATION_KO_INFO, CONFIRMATION_STATUS, CONFIRMATION_TYPES } from '@/utils/constants';
import BouncingLogo from '@/components/BouncingLogo';

const ConfirmationCheck = dynamic(() => import('./ConfirmationCheck'), { ssr: false });
const COMPONENT_NAME = 'Confirmation';

let printedEvent = false;

export const Confirmation = () => {
  const dispatch = useDispatch();

  const modalHistory = useSelector((state) => state.modals?.modalHistory);
  const confirmation = useSelector((state) => state.UI.confirmation);
  const clientModules = useSelector((state) => state.client.modulos);
  const modulos = useSelector((state) => state.cart.modulos);
  const layout = useSelector((state) => state.UI.layout);

  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    if (modalHistory && Array.isArray(modalHistory) && modalHistory.length > 0) {
      dispatch(
        modalActions.addModal({
          id: 'closeAll',
        }),
      );
    }
  }, []);

  const [activePromo, setActivePromo] = useState(0); // logica para mostrar mas confirmaciones

  const {
    type,
    productName,
    retentionProductName,
    status,
    info,
  } = confirmation || {};

  const {
    subject,
    title,
    description,
  } = info?.[activePromo] || CONFIRMATION_KO_INFO;

  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentProduct: getModuleNamesTagginInfo(modulos, layout, clientModules),
    componentContent: '',
    componentVariation: '',
  }

  switch (type) {
    case CONFIRMATION_TYPES.PREVENTION:
      taggingInfo.componentContent = `${status !== CONFIRMATION_STATUS.KO
        ? `send-movistar-layer${status === CONFIRMATION_STATUS.REDEEMED ? '_en-vuelo' : ''}`
        : status}`;
      taggingInfo.componentVariation = `baja_${productName || 'no-recuperado'}`;
      break;
    case CONFIRMATION_TYPES.BACKOFFICE:
      if (retentionProductName) {
        const segments = taggingInfo.componentProduct.split('||').filter(Boolean);
        const altasIndex = segments.findIndex((segment) => segment.startsWith('altas:'));
        if (altasIndex >= 0) {
          const products = segments[altasIndex].slice('altas:'.length).split(';');
          if (!products.includes(retentionProductName)) {
            products.push(retentionProductName);
          }
          segments[altasIndex] = `altas:${products.join(';')}`;
        } else {
          segments.push(`altas:${retentionProductName}`);
        }
        taggingInfo.componentProduct = segments.join('||');
      }
      taggingInfo.componentContent = `backOffice_${subject}` || '';
      taggingInfo.componentVariation = status || '';
      break;
    case CONFIRMATION_TYPES.CAPA:
      taggingInfo.componentContent = 'capa subscription';
      taggingInfo.componentVariation = status || '';
      break;
    case CONFIRMATION_TYPES.KEEP:
      taggingInfo.componentContent = 'mantener promo retention';
      taggingInfo.componentVariation = status || '';
      break;
    default:
      break;
  }

  if (status !== CONFIRMATION_STATUS.LOADING && !printedEvent) {
    printedEvent = true;
    sendGaEvent({ ...taggingInfo, eventType: 'print-success' });
  }

  return (
    <>
      <div className="Confirmation container">
        {status === CONFIRMATION_STATUS.LOADING && (
          <BouncingLogo />
        )}
        {status !== CONFIRMATION_STATUS.LOADING && (
          <>
            {status === CONFIRMATION_STATUS.OK && (
              <ConfirmationCheck />
            )}
            {status !== CONFIRMATION_STATUS.OK && (
              <Glyph
                id="alerta-m"
                height={125}
                width={125}
                color={COLOR_DICTIONARY.ORANGE}
              />
            )}
            {title && (
              <TextInfo
                kind={TEXT_KIND.PARAGRAPH}
                display={TEXT_DISPLAY.BLOCK}
                align={TEXT_ALIGN.CENTER}
                color={TEXT_COLOR.GREY6}
                size={TEXT_SIZE.T4}
                fontType={TEXT_FONT_WEIGHT.BOLD}
                text={title}
              />
            )}
            {description && (
              <TextInfo
                kind={TEXT_KIND.PARAGRAPH}
                display={TEXT_DISPLAY.BLOCK}
                align={TEXT_ALIGN.CENTER}
                color={TEXT_COLOR.GREY4}
                size={TEXT_SIZE.T6}
                fontType={TEXT_FONT_WEIGHT.LIGHT}
                text={description}
              />
            )}
            <Glyph
              id="telefonica-reducido-m"
              height={125}
              width={125}
              color={COLOR_DICTIONARY.MOVISTAR_BLUE}
            />
          </>
        )}
      </div>
      <style jsx>
        {`
          .Confirmation {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 1rem;
            min-height: 500px;
          }
        `}
      </style>
    </>
  );
};

export default Confirmation;
